import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { isEmpty } from "@/main/services/utils";

export const Container = styled.div`
	.MuiTableCell-root {
		padding: 6px 5px !important;
	}
	#id-collumn-searchclaim-partStatus {
		margin: 0;
		padding: 0;
	}
`;

export const StyledLink = styled(Link)`
	&&& {
		color: ${({ theme }) => theme.pantone2726C};
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
`;

export const CollumnSupplier = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 4px;
`;

export const SupplierNameWrapper = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	flex: 1;
	min-width: 0;
`;
export const CollumnPart = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: flex-start;
	min-width: 0;
	overflow: hidden;
	width: 100%;
`;

interface ICollumnDeadLineProps {
	$hasDeadline: boolean;
}
export const CollumnDeadLine = styled.div<ICollumnDeadLineProps>`
	display: flex;
	flex-direction: row;
	justify-content: center;
	position: relative;
	${({ $hasDeadline }) =>
		$hasDeadline &&
		css`
			color: red;
		`}
`;

export const AreaIconDeadline = styled.div`
	position: absolute;
	top: -2px;
	right: -4px;
`;

export const ReasonTooltip = styled.div`
	display: flex;
	flex-direction: column;
`;

export const CollumnLastMessage = styled.div`
	overflow: hidden;
	max-width: 100px;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

interface ICollumnStatusProps {
	$color?: string;
}
export const CollumnStatus = styled.div<ICollumnStatusProps>`
	display: flex;
	flex-direction: row;

	${({ $color }) =>
		!isEmpty($color) &&
		css`
			color: ${$color};
		`}
`;
export const TextPartStatus = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 120px;
	word-break: keep-all;
	font-weight: bold;
`;

export const AreaIconRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	gap: 5px;
`;

export const AreaTooltipPart = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;

	p {
		margin: 0;
	}
`;

export const AreaShippingCompanyPart = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 100px;
	margin: 0 auto;

	span {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: inherit;
		text-align: center;
	}

	p {
		margin: 0;
	}
`;
